import React from 'react';
import './Adds.css';
import classnames from 'classnames';


const script = document.createElement('script');
script.src = 'https://a.st1net.com/ad-provider.js';
script.async = true;
script.type = 'application/javascript';
script.id = 'shaft-ad-script';

class Adds extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      replaceAd: true,
      adProviderIsSet: false,
    };
  }

  setAdProvider = () => {
    if (window.AdProvider && this.state.adProviderIsSet) {
      return;
    }
    if (window.AdProvider && !this.state.adProviderIsSet) {
      window.AdProvider.push({ 'serve': {} });
      this.setState({ adProviderIsSet: true });
    } else {
      window.AdProvider = [];
    }
  };

  selectAd = () => {
    const num = Math.floor(Math.random() * 2);
    if (num === 0) {
      this.setState({ replaceAd: false });
    } else {
      this.setState({ replaceAd: true });
    }
  };

  componentDidMount() {
    const adScriptIsAdded = document.getElementById('shaft-ad-script');
    this.setState({ adProviderIsSet: false });
    if (!adScriptIsAdded) {
      document.head.appendChild(script);
    }
    this.setAdProvider();
    this.selectAd();
  }

  componentDidUpdate() {
    this.setAdProvider();
  }

  render() {
    const { replaceAd } = this.state;
    const { isAnchorPageAd, onlyShowMobileAds, adZoneToShow } = this.props;

    if (onlyShowMobileAds) {
      return (
        <div
          className={classnames({
            'anchor-page-ads': isAnchorPageAd,
            'adds': !isAnchorPageAd,
            'mobile-only': onlyShowMobileAds,
          })}
        >
          <div
            className={classnames({
              'hide-native-ad': replaceAd,
              'hide-ext-ad': !replaceAd,
            })}
          >
            <div className="native-ad mobile">
              <ins className="adsbyshafttraffic" data-zoneid={adZoneToShow} />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className={classnames({
          'anchor-page-ads': isAnchorPageAd,
          'adds': !isAnchorPageAd,
          'mobile-only': onlyShowMobileAds,
        })}
      >
        <div
          className={classnames({
            'hide-native-ad': replaceAd,
            'hide-ext-ad': !replaceAd,
          })}
        >
          <div className="native-ad desktop">
            <ins className="adsbyshafttraffic" data-zoneid="2424" />
          </div>
          <div className="native-ad mobile">
            <ins className="adsbyshafttraffic" data-zoneid="2454" />
          </div>
          {!isAnchorPageAd &&
            <div className="ext-ads desktop">
              <ins className="adsbyshafttraffic" data-zoneid="2424" />
            </div>
          }
          {isAnchorPageAd &&
            <div className="ext-ads desktop">
              <ins className="adsbyshafttraffic" data-zoneid="2436" />
              <ins className="adsbyshafttraffic" data-zoneid="2448" />
              <ins className="adsbyshafttraffic" data-zoneid="2450" />
            </div>
          }
          <div className="ext-ads mobile">
            <ins className="adsbyshafttraffic" data-zoneid="2442" />
          </div>
        </div>
      </div>
    );
  }
}

export default Adds;
